import pegasus  from "../../assets/scripts/global/01-pegasus.js";

document.addEventListener('alpine:init', () => {
    /**
     * FAQFilter Alpine component for search form
     */
    Alpine.data('FAQFilter', (term, options) => ({
        term: '',
        options: {},
        results: [],
        originUrl: window.location.origin,
        placeholder: 'What do you need help with?',
    
        init() {
            this.term = term;
            this.options = JSON.parse(options);
            window.addEventListener('popstate', () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path;
                }
            });

            const url = new URL(window.location.href);
            const search = url.search;

            if(typeof search === 'string' && search.length) {
                this.filterFAQs();
            }
            
        },

    
        liveSearch() {
            if (this.term.length > 2) {
                let searchUrl = `/wp-admin/admin-ajax.php?action=faq_live_search&term=${encodeURIComponent(this.term)}&faq-category=${encodeURIComponent(this.getSearchCategory())}`;
        
                const elements = ['data-pegasus-target="search-results"'];
                pegasus.ajaxContent(searchUrl, elements, {}, () => {
                
                });
            } else {
                const resultContainer = document.querySelector('[data-pegasus-target="search-results"]');
                if (resultContainer) {
                    resultContainer.innerHTML = '';
                }
            }
        },        
    
        selectResult(result) {
            this.term = result.title;
            this.results = [];
            this.filterFAQs(); 
        },
    
        filterFAQs() {
            this.$store.faqGlobal.searchSubmitted = true;
            let searchUrl = this.getSearchUrl();
            this.fetchContent(searchUrl);

            const targetElement = document.querySelector('.Accordion__Post_Grid');
            if (targetElement) {
                pegasus.scroll(targetElement, -100);
            } else {
                console.error('Element with class "Accordion__Post_Grid" not found.');
            }
        },


        getSearchUrl() {
            const url = new URL(window.location.href);
            const search = url.search;

            if(typeof search !== 'string' || !search.length) {
                return window.location.href + '?filter-search=' + this.term;
            }

            if(search.includes('filter-search')) {
                return search.replace(/filter-search=[^&]*/, 'filter-search=' + this.term);
            }

            return window.location.href + '&filter-search=' + this.term;
        },

        getSearchCategory() {
            const url = new URL(window.location.href);
            const search = new URLSearchParams(url.search);
            console.log(search);

            
                if(search.get('filter-t-faq-category') !== null) {
                    return search.get('filter-t-faq-category');
                }
            

            return '';
        },
        
        fetchContent(url) {            
            document.getElementById('LoadingScreen').style.display='block';
            console.log(url);
    
            const elements = ['data-pegasus-filterable="results"'];
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById('LoadingScreen').style.display='none';
                // Update the url with the current filters.
                history.pushState(JSON.stringify({}), '', url);
                this.updateSearchUI();
            });
        }, 
    
        updateSearchUI() {
            const searchTermWrap = document.querySelector('.js-accordion-search-term-wrap');
            const searchTerm = searchTermWrap.querySelector('.js-accordion-search-term');
            const filters = document.querySelector('.js-filters');
            const faqs = document.querySelector('[data-pegasus-filterable="results"]');
            const noResults = document.querySelector('.js-no-results');
            
            if (this.term !== '') {
                searchTermWrap.style.display = 'flex';
                noResults.style.display = 'none';
                searchTerm.innerHTML = this.term;
            } else {
                searchTermWrap.style.display = 'none';
                window.innerWidth > 768 ? filters.style.display = 'flex' : '';
            }
    
            if (faqs && faqs.children.length === 0) {
                noResults.style.display = 'block';
            } else {
                noResults.style.display = 'none';
            }
        },
    }))
    

    /**
     * FAQSelector Alpine component for filter buttons
     */
    Alpine.data('FAQSelector', () => ({
        currentlySelected: '', 

        init() {
            window.addEventListener('popstate', () => {
                if (window.history.state === null) {
                    location.reload();
                } else {
                    window.location = window.history.state.path;
                }
            });

            const url = new URL(window.location.href);
            const search = url.search;

            if(typeof search === 'string' && search.length) {
                if(search.includes('filter-t-faq-category')) {
                    this.currentlySelected = this.getUrlParam('filter-t-faq-category');
                }
            }

        },

        getUrlParam(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },

        filterFAQs(filterValue) {
            // Get the current origin and pathname dynamically
            let searchUrl = window.location.origin + window.location.pathname;
            
            if (filterValue !== '') {
                searchUrl += '?faq-search=1&filter-t-faq-category=' +  filterValue;
            }
            const term = this.getUrlParam('filter-search');
            if (term) {
                searchUrl = searchUrl + '&filter-search=' + term;
            }
            this.fetchContent(searchUrl);

            const targetElement = document.querySelector('.Accordion__Post_Grid');
            if (targetElement) {
                pegasus.scroll(targetElement, -100);
            }
        },

        toggleFilter(filterValue, filterName) {
            // If the clicked filter is already selected, reset the filter
            if (this.$store.faqGlobal.selectedTerm === filterName) {
                this.resetFilter();
            } else {
                this.filterFAQs(filterValue);
                this.selectTerm(filterName);
            }
        },
    
        resetFilter() {
            this.$store.faqGlobal.selectedTerm = '';
            let searchUrl = window.location.origin + window.location.pathname;
            this.fetchContent(searchUrl);
        },

        filterFAQs(filterValue) {
            // Get the current origin and pathname dynamically
            let searchUrl = window.location.origin + window.location.pathname;
            
            if (filterValue !== '') {
                searchUrl += '?faq-search=1&filter-t-faq-category=' +  filterValue;
            }
            const term = this.getUrlParam('filter-search');
            if (term) {
                searchUrl = searchUrl + '&filter-search=' + term;
            }
            this.fetchContent(searchUrl);
    
            const targetElement = document.querySelector('.Accordion__Post_Grid');
            if (targetElement) {
                pegasus.scroll(targetElement, -100);
            }
        },
    
        fetchContent(url) {
            const elements = ['data-pegasus-filterable="results"'];
            console.log(url);
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById('LoadingScreen').style.display='none';

                // Update the url with the current filters.
                history.pushState(JSON.stringify({}), '', url);

            });
        },
    }))

    /**
     * FAQFilter Alpine component for current term selected
     */
    Alpine.data('FaqSelected', (term) => ({
        term: '',
        selectedTerm: '',
        initialSearch: '',
        liveResultSelected: '',
    
        init() {
            this.term = term;
            // Ensure the store is available before accessing it
            if (this.$store && this.$store.faqGlobal) {
                this.selectedTerm = this.$store.faqGlobal.selectedTerm;
            }
        },
    
        selectTerm(termName) {
            if (this.$store && this.$store.faqGlobal) {
                this.selectedTerm = termName;
                this.$store.faqGlobal.selectedTerm = termName;
            }
        },
    
        selectResult(result) {
            this.term = result;
            this.filterFAQs(); 
            
            const targetElement = document.querySelector('.Accordion__Post_Grid');
            if (targetElement) {
                pegasus.scroll(targetElement, -100);
            }
        },
    
        filterFAQs() {
            this.$store.faqGlobal.searchSubmitted = true;
            let searchUrl = '?filter-search=' + this.term;
            this.fetchContent(searchUrl);
        },

        fetchContent(url) {            
            document.getElementById('LoadingScreen').style.display='block';
    
            const elements = ['data-pegasus-filterable="results"'];
            pegasus.ajaxContent(url, elements, {}, () => {
                document.getElementById('LoadingScreen').style.display='none';
                this.updateSearchUI();
            });
        },

        updateSearchUI() {
            const searchTermWrap = document.querySelector('.js-accordion-search-term-wrap');
            const searchTerm = searchTermWrap.querySelector('.js-accordion-search-term');
            const filters = document.querySelector('.js-filters');
            const faqs = document.querySelector('[data-pegasus-filterable="results"]');
            const noResults = document.querySelector('.js-no-results');
            
            if (this.term !== '') {
                searchTermWrap.style.display = 'block';
                noResults.style.display = 'none';
                searchTerm.innerHTML = this.term;
            } else {
                searchTermWrap.style.display = 'none';
                window.innerWidth > 768 ? filters.style.display = 'flex' : '';
            }
    
            if (faqs && faqs.children.length === 0) {
                noResults.style.display = 'block';
            } else {
                noResults.style.display = 'none';
            }
        },
    }));
    
    
});
